import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';

import { UPDATE_ORDER_HIDDEN_FROM_DEALER } from './queries';

const FIELDS = {
  note: {
    label: 'Optional Note',
  },
};

const HideFromDealer = ({ order, setShow, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [updateOrderHiddenFromDealer] = useMutation(
    UPDATE_ORDER_HIDDEN_FROM_DEALER, {
      onCompleted: () => { setShow(false); refetch(); }
    },
  );

  const onSubmit = input => {
    setFormStatus('submitting');
    updateOrderHiddenFromDealer({
      variables: {
        id: order.id,
        hideFromDealer: !order.hiddenFromDealerAt,
        ...input
      }
    });
  };

  let title = 'Hide Order from Dealer';

  if (order.hiddenFromDealerAt) {
    title = 'Show Order to Dealer (un-hide)';
  }

  return (
    <Modal title={title} setShow={setShow}>
      <Text style={{ marginBottom: 10 }}>
        When an order is hidden from a dealer, they don't see it in their order
        list and do not see unregistered tags in their tag log. The dealer is
        allowed to pre-register tags in hidden orders, but a data check will
        create a system notice.
      </Text>

      <Text style={{ marginBottom: 10 }}>
        Orders are auto-hidden after one year if no tags are pre-registered.
        The intention is to avoid showing data that the dealer probably doesn't
        care about. The ability to manually hide an order is intended for
        situations when an order was delivered then we found out there was
        something wrong and the dealer will not be using these tags.
      </Text>

      <Fields fields={FIELDS} control={control} errors={errors} />

      {'submitting' === formStatus ? (
        <Text>Processing...</Text>
      ) : (
        <Button label={title} onPress={handleSubmit(onSubmit)} wide />
      )}
    </Modal>
  );
};

export default HideFromDealer;
